export interface CustomError {
    key: string;
    message: string;
    code?: string;
}

export interface CustomResponse extends Response {
    data?: any;
    errors?: CustomError[];
}

function getHeaders(options: RequestInit): Headers {
    const headers = options.headers ? new Headers(options.headers) : new Headers();
    headers.set('Accept', 'application/json');
    headers.set('Accept-Language', 'nl-NL');

    if (!(options.body instanceof FormData)) {
        headers.set('Content-Type', 'application/json');
    }

    return headers;
}

export async function customFetch(url: RequestInfo, options?: RequestInit) : Promise<CustomResponse> {
    options = {
        credentials: 'include',
        cache: 'no-store',
        ...options
    };

    options.headers = getHeaders(options);

    let response: CustomResponse = await fetch(url, options);

    const contentType = response.headers.get('Content-Type') || '';
    if (contentType.includes('application/json')) {
        const data = await response.json();
        if (response.ok) {
            response.data = data;
        } else {
            response.errors = data.errors;
        }
    }

    return response;
}
